module.exports = __webpack_public_path__ + "img/1f4e5e0.jpg";